var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFitnessHeartRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2015 7.14252C29.6575 6.07828 28.8702 5.15735 27.9034 4.45451C26.9367 3.75167 25.8179 3.28674 24.6377 3.09748C23.4576 2.90822 22.2495 2.99996 21.1115 3.36525C19.9735 3.73055 18.9376 4.3591 18.0881 5.19985L16.0001 7.10518L13.9121 5.19985C13.0624 4.35924 12.0263 3.73093 10.8881 3.36593C9.74987 3.00093 8.54162 2.90955 7.36146 3.09921C6.18131 3.28886 5.06252 3.75421 4.09599 4.45745C3.12945 5.16069 2.34241 6.08199 1.7988 7.14652C1.08919 8.55243 0.844091 10.1473 1.0988 11.7014C1.3535 13.2555 2.09487 14.6887 3.21613 15.7945L16.0001 28.9998L28.7841 15.7905C29.9054 14.6847 30.6468 13.2515 30.9015 11.6974C31.1562 10.1433 30.9111 8.54843 30.2015 7.14252V7.14252Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.9997H10.6907C10.7836 13.9997 10.8747 14.0255 10.9538 14.0742C11.0329 14.1229 11.0969 14.1927 11.1387 14.2757L13.5027 19.0037C13.5458 19.0897 13.6129 19.1614 13.6958 19.2103C13.7787 19.2591 13.8739 19.283 13.9701 19.2791C14.0662 19.2751 14.1592 19.2435 14.2378 19.188C14.3164 19.1326 14.3774 19.0556 14.4133 18.9664L17.5867 11.033C17.6226 10.9438 17.6836 10.8668 17.7622 10.8113C17.8408 10.7559 17.9338 10.7243 18.0299 10.7203C18.1261 10.7164 18.2213 10.7403 18.3042 10.7891C18.3871 10.838 18.4542 10.9097 18.4973 10.9957L19.8667 13.7237C19.9084 13.8067 19.9724 13.8765 20.0515 13.9252C20.1307 13.9739 20.2218 13.9997 20.3147 13.9997H25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitnessHeartRate);
export default __webpack_public_path__ + "static/media/FitnessHeartRate.a3576d5405070c48e92a29af25d955fd.svg";
export { ForwardRef as ReactComponent };